const defaultOptions: MutationObserverInit = {
	attributes: true,
	characterData: true,
	childList: true,
	subtree: true,
};

export const createMutationObserver = (
	hostElement: HTMLElement,
	mutationCallback: MutationCallback,
	options: MutationObserverInit = defaultOptions,
) => {
	const modifiedMutationCallback = (mutations: MutationRecord[], observer: MutationObserver) => {
		// Should not react on attribute changes on the hostElement, just on child elements
		if (mutations[0].target === hostElement && mutations[0].type === 'attributes') {
			return;
		}

		mutationCallback(mutations, observer);
	};

	const mutationObserver = new MutationObserver(modifiedMutationCallback);
	mutationObserver.observe(hostElement, options);
	return mutationObserver;
};
